import api from './client';

export interface ResolveCutInput {
  message: string;
  projectId: string;
  suggestedCutName?: string;
  candidateCuts?: Array<{ id: string; name: string; vibeName?: string }>;
}

export interface ResolveCutResponse {
  cutId: string | null;
  confidence: number;
  reason: string;
}

export async function resolveCutTarget(input: ResolveCutInput): Promise<ResolveCutResponse> {
  const { data } = await api.post<ResolveCutResponse>('/ai/resolve-cut', input);
  return data;
}
